// IMPORTANT!: DON'T make ANY changes about this class!!!! Required for devexpress Framework
export class SchedulerColumn {
  id: number;
  text: string;
  color: string;
}
